import { render, staticRenderFns } from "./DashboardCadastro.vue?vue&type=template&id=0d09ed0b&"
import script from "./DashboardCadastro.vue?vue&type=script&lang=js&"
export * from "./DashboardCadastro.vue?vue&type=script&lang=js&"
import style0 from "../assets/default.styl?vue&type=style&index=0&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports